<script>
import _ from 'underscore'
import Choices from 'choices.js'
import { mapGetters } from 'vuex'

import eventBus from '@utils/eventBus'
import Layout from '@layouts/main.vue'

import AttractionsGrid from '@components/attractions/attractions-grid.vue'
import AttractionsList from '@components/attractions/attractions-list.vue'
import AttractionsMap from '@components/attractions/attractions-map.vue'
import Calculator from '@components/attractions/savings-calculator.vue'
import FreeAttractions from '@components/common/sliders/free-attractions-slider.vue'
import AreaCard from '@components/area-card.vue'
import SearchInput from '@components/navigation/search/search-input.vue'

import SearchMixin from '@src/mixins/searchMixin'
import Resizable from '@src/mixins/resizable.js'
import Translatable from '@src/mixins/translatable.js'
import ImageMixin from '@src/mixins/imageMixin.js'
import AuthorLabel from '@src/mixins/author.js'

export default {
  page: {
    title: '80+ Attractions Included',
    meta: [
      {
        name: 'description',
        content:
          'Prague Castle - National Museum - Jewish Museum and Synagogues - National Gallery - Prague Zoo...',
      },
    ],
  },
  components: {
    Layout,
    AttractionsGrid,
    AttractionsList,
    AttractionsMap,
    Calculator,
    FreeAttractions,
    AreaCard,
    SearchInput,
  },
  mixins: [SearchMixin, Translatable, Resizable, ImageMixin, AuthorLabel],
  data() {
    return {
      LIST_VIEW_COMPONENT_NAME: 'AttractionsList',
      GRID_VIEW_COMPONENT_NAME: 'AttractionsGrid',
      MAP_VIEW_COMPONENT_NAME: 'AttractionsMap',
      displayCalculator: true,
      filters: [],
      regionSelect: null,
      attractionsFilterSelect: null,
      attractionsSearchInput: null,
      // searchRegion: 'all',
      // attractionsOrdering: 'popularity',
      isOpened: false,
      isMapView: false,
    }
  },
  computed: {
    ...mapGetters('categories', ['categories', 'tourCategories']),
    ...mapGetters('attractions', [
      'attractions',
      'freeEntryAttractions',
      'likedAttractions',
      'currentAttractionsView',
      'searchRegion',
      'attractionsOrdering',
      'attractionsToDisplay',
      'aisLoading',
    ]),
    ...mapGetters('areas', ['mainAreas', 'areas']),
    ...mapGetters('attractionsPage', ['pageData']),
    ...mapGetters('translations', ['isTranslated']),
    pageImg() {
      if (this.pageData.mainImage) {
        return this.desktopScreen
          ? this.pageData.mainImage.web_image
          : this.pageData.mainImage.app_image
      }
      return ''
    },
    attractionsSearchList() {
      return this.formatAttractions(this.attractions)
    },
    attractionsList() {
      return this.filteredAttractions.filter(
        (attraction) => attraction.typology !== 'pc_free_entry'
      )
    },
    tourCategoriesList() {
      return this.tourCategories.map((tour) => tour._id)
    },
    categoryTitle() {
      const categories = [...this.categories, ...this.tourCategories]

      const selected =
        this.filters.length > 1
          ? this.getTranslatedContent('ATTRACTIONS_sightseeing_tours_title')
          : this.filters[0] ||
            this.getTranslatedContent('ATTRACTIONS_all_attractions_title')

      const category = categories.find((c) => c._id === selected)
      return category
        ? category.content[this.currentLanguage].title ||
            category.content.en.title
        : `${selected}`
    },
    filteredAttractions() {
      if (this.filters.length) {
        return this.orderedByRegionAttractions.filter((attraction) => {
          return (
            _.intersection(attraction.categories, this.filters).length !== 0
          )
        })
      } else {
        this.$store.commit(
          'attractions/SET_FILTERED_ATTRACTIONS',
          this.orderedByRegionAttractions
        )
        return this.orderedByRegionAttractions
      }
    },
    orderedByRegionAttractions() {
      if (this.searchRegion === 'all') {
        return this.orderedAttractions
      } else {
        return this.orderedAttractions.filter((attraction) => {
          return attraction.area === this.searchRegion
        })
      }
    },
    orderedAttractions() {
      switch (this.attractionsOrdering) {
        case 'popularity':
          return _.sortBy(this.attractions, (attraction) => {
            return parseInt(attraction.order)
          })
        case 'alphanumeric':
          return _.sortBy(this.attractions, (attraction) => {
            return attraction.content[this.currentLanguage].title
          })
        case 'free':
          return _.sortBy(this.attractions, (attraction) => {
            return parseInt(attraction.benefitAdult) === 0 ? -1 : 1
          })
        case 'discounts':
          return _.sortBy(this.attractions, (attraction) => {
            return parseInt(attraction.benefitAdult) !== 0 ? -1 : 1
          })
        default:
          return this.attractions
      }
    },
    toggleBtnLabel() {
      return this.displayCalculator
        ? this.getTranslatedContent('CALCULATOR_hide_calculator')
        : this.getTranslatedContent('CALCULATOR_show_calculator')
    },
    openedCalculator() {
      if (this.desktopScreen) {
        return true
      }
      return this.likedAttractions.length
    },
  },
  created() {
    // this.$store.dispatch('attractions/fetchAttractions')
    this.$store.dispatch('categories/fetchCategories')
    this.$store.dispatch('areas/fetchAreas')
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'areas/SET_AREAS' && this.regionSelect) {
        this.regionSelect.setChoices([
          {
            value: 'all',
            label: this.getTranslatedContent('ATTRACTIONS_filter_areas_all'),
            selected: this.searchRegion === 'all',
          },
        ])
        this.$nextTick(() => {
          this.regionSelect.setChoices(
            this.areas.map((area) => {
              return {
                value: area._id,
                label: this.getTranslatedContent(
                  'title',
                  area.content
                ).toLowerCase(),
                selected: this.searchRegion === area._id,
              }
            })
          )
        })
      }
    })

    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === 'categories/SET_CATEGORIES' &&
        this.$route.query.category === 'sightseeing'
      ) {
        this.filters = this.tourCategoriesList
      }
    })
  },
  mounted() {
    // if (this.$refs.filterDropdown) {
    //   this.setSelectsChoices()
    // }
  },
  updated() {
    if (this.isTranslated) {
      this.setRegionSelect()
      this.setAttractionsFilterSelect()

      this.$store.commit('translations/SET_IS_TRANSLATED', false)
    }

    if (this.$refs.filterDropdown && !this.attractionsFilterSelect) {
      this.setSelectsChoices()
    }

    this.isMapView =
      this.currentAttractionsView === this.MAP_VIEW_COMPONENT_NAME

    this.$store.commit(
      'attractions/SET_FILTERED_ATTRACTIONS',
      this.filteredAttractions
    )

    if (this.$refs.filterDropdown) {
      this.$refs.filterDropdown.addEventListener('change', (data) => {
        // this.attractionsOrdering = data.detail.value
        this.$store.commit('attractions/SET_ORDERING', data.detail.value)

        this.$store.commit(
          'attractions/SET_FILTERED_ATTRACTIONS',
          this.filteredAttractions
        )
      })

      this.$refs.regionSelect.addEventListener('change', (data) => {
        // this.searchRegion = data.detail.value
        this.$store.commit('attractions/SET_AREA_FILTER', data.detail.value)

        this.$store.commit(
          'attractions/SET_FILTERED_ATTRACTIONS',
          this.filteredAttractions
        )
      })
    }
  },
  watch: {
    '$route.query.category': {
      immediate: true,
      handler(category) {
        if (category) {
          this.selectCategory(category)
        }
      },
    },
  },
  methods: {
    setSelectsChoices() {
      this.regionSelect = new Choices('#regionSelect', {
        silent: false,
        removeItems: false,
        searchEnabled: false,
        shouldSort: false,
        noChoicesText: '',
        loadingText: 'Loading...',
        classNames: {
          containerOuter: 'region-select',
          containerInner: 'inner-container',
          itemSelectable: 'selected-region',
          openState: 'select-opened',
          listDropdown: 'regions-container',
          list: 'regions-list',
        },
      })

      this.attractionsFilterSelect = new Choices('#filter-dropdown', {
        silent: false,
        removeItems: true,
        searchEnabled: false,
        noChoicesText: '',
        choices: [
          {
            label: this.getTranslatedContent('ATTRACTIONS_order_by_popularity'),
            value: 'popularity',
            selected: this.attractionsOrdering === 'popularity',
          },
          {
            label: this.getTranslatedContent('ATTRACTIONS_order_by_az'),
            value: 'alphanumeric',
            selected: this.attractionsOrdering === 'alphanumeric',
          },
          {
            label: this.getTranslatedContent('ATTRACTIONS_order_by_free'),
            value: 'free',
            selected: this.attractionsOrdering === 'free',
          },
          {
            label: this.getTranslatedContent('ATTRACTIONS_order_by_discounts'),
            value: 'discounts',
            selected: this.attractionsOrdering === 'discounts',
          },
        ],
        classNames: {
          containerOuter: 'filter-dropdown',
          containerInner: 'inner-container',
          itemSelectable: 'selected-filter',
          openState: 'select-opened',
          listDropdown: 'filters-container',
          list: 'filters-list',
        },
      })
    },
    toggleCalculator() {
      this.displayCalculator = !this.displayCalculator
      this.$refs.attractionsContainer.classList.toggle('expanded')
      eventBus.$emit('toggle')
    },
    toggleCalculatorMobile() {
      if (!this.desktopScreen) {
        this.isOpened = !this.isOpened
        document.body.style.overflow = this.isOpened ? 'hidden' : ''
      }
    },
    switchView(viewName) {
      this.$store.commit('attractions/SET_ATTRACTION_VIEW', viewName)
    },
    isActive(viewName) {
      return this.currentAttractionsView === viewName ? 'active' : ''
    },
    backgroundImage(area) {
      return {
        backgroundImage: `url(${process.env.VUE_APP_STATIC_URL}${area.image})`,
      }
    },
    setRegionSelect() {
      this.regionSelect.clearChoices()

      this.regionSelect.setChoices([
        {
          value: 'all',
          label: this.getTranslatedContent('ATTRACTIONS_filter_areas_all'),
          selected: this.searchRegion === 'all',
        },
      ])
      this.regionSelect.setChoices(
        this.areas.map((area) => {
          return {
            value: area._id,
            label: this.getTranslatedContent(
              'title',
              area.content
            ).toLowerCase(),
            selected: this.searchRegion === area._id,
          }
        })
      )
    },
    setAttractionsFilterSelect() {
      this.attractionsFilterSelect.clearChoices()
      this.attractionsFilterSelect.setChoices([
        {
          label: this.getTranslatedContent('ATTRACTIONS_order_by_popularity'),
          value: 'popularity',
          selected: this.attractionsOrdering === 'popularity',
        },
        {
          label: this.getTranslatedContent('ATTRACTIONS_order_by_az'),
          value: 'alphanumeric',
          selected: this.attractionsOrdering === 'alphanumeric',
        },
        {
          label: this.getTranslatedContent('ATTRACTIONS_order_by_free'),
          value: 'free',
          selected: this.attractionsOrdering === 'free',
        },
        {
          label: this.getTranslatedContent('ATTRACTIONS_order_by_discounts'),
          value: 'discounts',
          selected: this.attractionsOrdering === 'discounts',
        },
      ])
    },
    selectCategory(categoryId) {
      // if (_.contains(this.filters, categoryId)) {
      // const index = this.filters.indexOf(categoryId);
      // this.filters.splice(index, 1);
      // }
      let categories = ''
      if (categoryId === 'all') {
        categories = 'all'
        this.filters = []
      } else if (categoryId === 'sightseeing') {
        categories = 'sightseeing'
        this.filters = this.tourCategoriesList
      } else {
        categories = categoryId
        this.filters = [categoryId]
      }
      this.setRegionSelect()
      this.setAttractionsFilterSelect()
      this.$store.commit(
        'attractions/SET_FILTERED_ATTRACTIONS',
        this.filteredAttractions
      )
      this.$router.replace({ query: { category: categories } }).catch(() => {})
    },
    pageContentU(prop) {
      if (this.pageData.content) {
        return this.pageData.content[this.currentLanguage][prop]
          ? this.pageData.content[this.currentLanguage][prop]
          : this.pageData.content.en[prop]
      }
      return []
    },
  },
}
</script>

<template>
  <Layout>
    <section
      class="attractions-header justify-center"
      :style="getBackground(pageImg)"
    >
      <div class="container">
        <div class="header-title">
          <h1
            class="title"
            v-html="getTranslatedContent('title', pageData.content)"
          >
          </h1>
          <h3
            class="subtitle"
            v-html="getTranslatedContent('subtitle', pageData.content)"
          >
          </h3>
        </div>
      </div>
    </section>
    <section class="categories-tabs justify-center">
      <p class="author container" v-html="authorLabel(pageData)"></p>
      <div class="container categories">
        <div class="row filters">
          <div class="search-container">
            <SearchInput :type-of="'attraction'" />
          </div>
        </div>
        <div class="categories-list">
          <div class="row main-categories">
            <div
              id="all-attractions-categories"
              class="category"
              :class="filters.length === 0 ? 'active' : ''"
              @click="selectCategory('all')"
            >
              <p>{{
                getTranslatedContent('ATTRACTIONS_all_attractions_title')
              }}</p>
            </div>
            <div
              v-for="(category, index) in categories"
              :key="index"
              class="category"
              :class="filters.includes(category._id) ? 'active' : ''"
              @click="selectCategory(category._id)"
            >
              <p>{{ getTranslatedContent('title', category.content) }}</p>
            </div>
          </div>
          <div class="separator"></div>
          <div class="row tours">
            <div
              id="all-attractions-categories"
              class="category"
              :class="filters.length > 1 ? 'active' : ''"
              @click="selectCategory('sightseeing')"
            >
              <p>{{
                getTranslatedContent('ATTRACTIONS_sightseeing_tours_title')
              }}</p>
            </div>
            <div
              v-for="(category, index) in tourCategories"
              :key="index"
              class="category"
              :class="
                filters.length === 1 && filters.includes(category._id)
                  ? 'active'
                  : ''
              "
              @click="selectCategory(category._id)"
            >
              <p>{{ getTranslatedContent('title', category.content) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <main id="all-attractions" class="content justify-center">
      <div class="container">
        <div class="content-header row">
          <h3 v-html="categoryTitle"></h3>
          <div class="switches">
            <div
              class="grid"
              :class="isActive(GRID_VIEW_COMPONENT_NAME)"
              :displayCalculator="displayCalculator"
              @click="switchView(GRID_VIEW_COMPONENT_NAME)"
            >
            </div>
            <div
              class="list"
              :class="isActive(LIST_VIEW_COMPONENT_NAME)"
              @click="switchView(LIST_VIEW_COMPONENT_NAME)"
            >
            </div>
            <div
              class="map"
              :class="isActive(MAP_VIEW_COMPONENT_NAME)"
              @click="switchView(MAP_VIEW_COMPONENT_NAME)"
            >
            </div>
          </div>
          <label for="regionSelect"></label>
          <select id="regionSelect" ref="regionSelect" class="filter-dropdown">
          </select>
          <label for="filter-dropdown"></label>
          <div v-show="!isMapView" class="filter-dropdown-container">
            <select
              id="filter-dropdown"
              ref="filterDropdown"
              class="filter-dropdown"
            >
            </select>
          </div>
          <div id="toggle-calculator" @click="toggleCalculator"
            ><span>{{ toggleBtnLabel }}</span></div
          >
        </div>
        <div
          v-if="!desktopScreen && !likedAttractions.length"
          class="calculator-tip"
          v-html="getTranslatedContent('CALCULATOR_tip')"
        >
        </div>
        <div ref="attractionsContainer" class="main-content">
          <div v-if="attractionsList.length || isMapView" class="attractions">
            <keep-alive>
              <component
                :is="currentAttractionsView"
                :attractions="attractionsList"
                :filters="filters"
                :searchRegion="searchRegion"
                :attractionsToDisplay="attractionsToDisplay"
              ></component>
            </keep-alive>
          </div>
          <div
            v-else-if="!attractionsList.length && aisLoading"
            class="load"
          ></div>
          <h1
            class="no-results"
            v-else
            v-html="getTranslatedContent('ATTRACTIONS_no_results')"
          ></h1>
          <div
            v-show="displayCalculator && openedCalculator"
            :class="isOpened ? 'calculator-opened' : 'calculator'"
          >
            <Calculator
              :is-opened="isOpened"
              @toggle-calculator-mobile="toggleCalculatorMobile"
            />
          </div>
        </div>
      </div>
    </main>
    <section
      v-if="freeEntryAttractions.length"
      id="free-attractions"
      class="free-attractions"
    >
      <div class="container">
        <h3
          class="free-title"
          v-html="getTranslatedContent('ATTRACTIONS_free_entry_attractions')"
        ></h3>
        <p
          class="free-subtitle"
          v-html="pageContentU('free_entry_description')"
        ></p>
      </div>
      <FreeAttractions class="free-attractions-slider" />
    </section>
    <section id="areas" class="justify-center prague-areas">
      <div class="container">
        <h3 v-html="getTranslatedContent('ATTRACTIONS_prague_areas')"></h3>
        <div class="areas-wrapper">
          <AreaCard v-for="area in mainAreas" :key="area._id" :area="area" />
        </div>
        <router-link :to="{ name: 'areas' }" class="link">
          <button class="show-all-btn">{{
            getTranslatedContent('ATTRACTIONS_show_all_areas')
          }}</button>
        </router-link>
      </div>
    </section>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.load {
  width: 850px;
}

.no-results {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
}

.link {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  text-decoration: none;

  .show-all-btn {
    min-width: 191px;
    height: 48px;
    padding: 0 20px;

    border: 1px solid $dark-gray;
    box-sizing: border-box;
    border-radius: 5px;
    background-color: white;

    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    text-transform: uppercase;
    color: rgba(37, 44, 62, 0.6);

    &:hover {
      border: 1px solid rgba(37, 44, 62, 0.6);
    }
  }
}

::v-deep .free-subtitle {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $black;
  user-select: none;

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & .ql-align-center {
    text-align: center;
  }
}

.free-title {
  margin-bottom: 15px;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $screen-width-xs) {
  .attractions-header {
    height: 244px;

    & .container {
      padding: 0;
    }
  }

  .header-title {
    width: 100%;
    box-sizing: border-box;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 20px;
    margin-top: 70px;
    height: 125px;

    & h1.title {
      font-family: Open Sans Bold, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 34px;
      text-transform: uppercase;
      color: #ffffff;
      margin: 0 0 10px;
    }

    & h3.subtitle {
      font-family: Open Sans Semibold, sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: #ffffff;
      margin: 5px 0 0;
    }
  }

  .categories-tabs {
    margin-top: -23px;

    & .categories {
      padding-top: 20px;
      padding-bottom: 20px;
      border-radius: 20px 20px 0 0;
      box-sizing: border-box;
    }
  }

  .search-container {
    width: 100%;
    margin-bottom: 10px;
  }

  .categories-list {
    .all-attractions {
      font-family: Open Sans Bold, sans-serif;
      font-weight: bold;
      text-align: center;
    }

    .category {
      height: 32px;
      padding: 8px 10px 8px 10px;
      border: 1px solid #ffffff;
      box-sizing: border-box;
      border-radius: 5px;
      cursor: pointer;
      margin-right: 5px;
      margin-bottom: 8px;

      &:last-child {
        margin-right: 0;
      }

      p {
        font-family: Open Sans Semibold, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 130%;
      }

      &.active {
        background: $light-gray;

        p {
          font-family: Open Sans Bold, sans-serif;
          font-weight: bold;
          text-align: center;
          color: #252c3e;
        }
      }
    }

    & .separator {
      width: 100%;
      height: 0;
      border: 1px solid $hover-orange;
      background: $hover-orange;
    }
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
  }

  main {
    padding-top: 20px;

    & .container {
      padding: 0;
    }

    & .content-header {
      padding-right: 8px;
      padding-left: 8px;
      box-sizing: border-box;
    }
  }

  .switches {
    margin-left: auto;
    margin-right: 5px;
  }

  #toggle-calculator {
    display: none;
  }

  ::v-deep .filter-dropdown {
    flex-basis: 100%;
    border-radius: 5px;
    margin-top: 9px;
  }

  ::v-deep .region-select {
    width: 100%;
    margin-bottom: 5px;
    margin-top: 15px;
  }

  .main-content {
    margin-top: 10px;
  }

  .prague-areas {
    & .container {
      padding: 0;

      & h3 {
        padding-left: 8px;
        padding-right: 8px;
      }
    }
  }

  .areas-wrapper {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-top: 15px;
  }
}

@media only screen and (min-width: $screen-width-xs + 1) {
  h3 {
    font-size: 22px;
    line-height: 29px;
  }

  .attractions-header {
    width: 100%;
    height: 550px;
    background-repeat: no-repeat;
    background-position: center;

    & .header-title {
      width: 840px;
      height: 135px;

      margin-top: 217px;
      padding-top: 9px;

      h1 {
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 48px;
        line-height: 62px;
        color: #ffffff;

        text-transform: uppercase;

        margin-left: 22px;
      }

      h3 {
        font-family: Open Sans Semibold, sans-serif;
        font-weight: 600;
        font-size: 22px;
        line-height: 29px;
        color: #ffffff;

        margin-left: 25px;
      }
    }
  }

  .search-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 274px;
  }

  .magnifying-glass {
    width: 20px;
    height: 20px;
    background: url('../../../assets/icons/search.svg') center;
    cursor: pointer;
    z-index: 1;
    margin-left: -31px;
  }

  .categories-tabs {
    margin-top: -99px;

    & .categories {
      width: 1141px;
      min-height: 209px;
      background: $dark-blue;
      box-shadow: 0 8px 12px rgba(76, 72, 124, 0.08);
      border-radius: 20px;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      & .categories-list {
        margin-top: 18px;

        #all-attractions {
          font-family: Open Sans Bold, sans-serif;
          font-weight: bold;
          text-align: center;

          & p {
            font-size: 15px;
            line-height: 19px;
          }
        }

        .category {
          padding: 12px 20px;
          height: 45px;
          border: 1px solid #ffffff;
          box-sizing: border-box;
          border-radius: 5px;

          margin-right: 10px;
          margin-bottom: 12px;
          cursor: pointer;

          p {
            font-family: Open Sans Bold, sans-serif;
            font-weight: bold;
            font-size: 16px;
            line-height: 21px;
            text-align: center;
            color: #ffffff;
          }

          &.active,
          &:hover {
            height: 45px;
            background: $light-gray;
            border-radius: 5px;

            p {
              font-family: Open Sans Bold, sans-serif;
              font-weight: bold;
              text-align: center;
              color: #252c3e;
            }
          }
        }

        & .separator {
          width: 100%;
          height: 0;
          border: 1px solid $hover-orange;
          background: $hover-orange;
          margin-bottom: 12px;
        }
      }
    }
  }

  .content {
    margin-top: 61px;

    & .main-content {
      display: grid;
      grid-template-columns: 850px 269px;
      // grid-template-columns: 1fr;

      column-gap: 21px;

      &.expanded {
        grid-template-columns: 1fr;
        // grid-template-columns: 850px 269px;
      }
    }
  }

  .content-header {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;

    #toggle-calculator {
      width: 269px;
      height: 37px;
      margin-left: auto;
      background: $dark-blue;
      border-radius: 5px;
      box-sizing: border-box;
      padding-left: 15px;
      cursor: pointer;

      display: flex;
      align-items: center;

      &:hover {
        background: $hover-blue;
      }

      & span {
        font-family: Open Sans, sans-serif;
        font-weight: normal;
        font-size: 14px;
        line-height: 23px;
        color: #ffffff;
        text-transform: capitalize;
        user-select: none;
      }
    }
  }

  ::v-deep .filter-dropdown {
    width: 198px;
    height: 35px;
    background: #ffffff;
    border: 1px solid $dark-gray;
    border-radius: 5px;
    box-sizing: border-box;
    margin-left: 16px;
    position: relative;
    cursor: pointer;

    & .inner-container {
      padding: 6px 17px 6px 15px;
      height: 100%;
      box-sizing: border-box;

      & .filters-list {
        & .selected-filter {
          font-family: Open Sans, sans-serif;
          font-weight: normal;
          font-size: 14px;
          line-height: 23px;
          color: #252527;
        }
      }
    }

    & .filters-container {
      position: absolute;
      top: 100%;
      width: 100%;
      border-radius: 0 0 5px 5px;
      background: #ffffff;
      visibility: hidden;
      z-index: 1;

      & .filters-list {
        & div {
          font-family: Open Sans, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 23px;
          color: #252527;
          padding-top: 3px;
          padding-bottom: 8px;
          padding-left: 15px;
          position: relative;

          &:before {
            content: '';
            width: 147px;
            height: 1px;
            background-color: $light-gray;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -73.5px;
          }

          &:hover {
            background-color: $light-gray;
          }

          &:last-child {
            padding-bottom: 10px;

            &:hover {
              border-radius: 0 0 5px 5px;
            }
          }
        }

        & .has-no-choices {
          padding: 0 !important;
        }
      }
    }

    &.select-opened .filters-container {
      border-bottom: 1px solid #fdca2e;
      border-left: 1px solid #fdca2e;
      border-right: 1px solid #fdca2e;
      visibility: visible;
      margin-left: -1px;
    }

    &::after {
      content: '';
      background: url('../../../assets/icons/select-arrow-down.svg') center
        no-repeat;
      width: 8px;
      height: 6px;
      position: absolute;
      top: 15px;
      right: 17px;
      cursor: pointer;
    }

    &.select-opened {
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 5px;

      &:after {
        background: url('../../../assets/icons/select-arrow-up.svg') center
          no-repeat;
      }
    }
  }

  ::v-deep .region-select {
    width: 198px;
    height: 35px;
    background: #ffffff;
    border: 1px solid $dark-gray;
    border-radius: 5px;
    box-sizing: border-box;
    margin-left: 16px;
    position: relative;
    cursor: pointer;

    & .inner-container {
      padding: 6px 17px 6px 15px;
      height: 100%;
      box-sizing: border-box;

      & .regions-list {
        & .selected-filter {
          font-family: Open Sans, sans-serif;
          font-weight: normal;
          font-size: 14px;
          line-height: 23px;
          color: #252527;
        }
      }
    }

    & .regions-container {
      position: absolute;
      top: 100%;
      width: 100%;
      border-radius: 0 0 5px 5px;
      background: #ffffff;
      visibility: hidden;
      z-index: 1;

      & .regions-list {
        & div {
          font-family: Open Sans, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 23px;
          color: #252527;
          padding-top: 3px;
          padding-bottom: 8px;
          padding-left: 15px;
          position: relative;

          &:before {
            content: '';
            width: 147px;
            height: 1px;
            background-color: $light-gray;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -73.5px;
          }

          &:hover {
            background-color: $light-gray;
          }

          &:last-child {
            padding-bottom: 10px;

            &:hover {
              border-radius: 0 0 5px 5px;
            }
          }
        }

        & .has-no-choices {
          padding: 0 !important;
        }
      }
    }

    &.select-opened .regions-container {
      border-bottom: 1px solid #fdca2e;
      border-left: 1px solid #fdca2e;
      border-right: 1px solid #fdca2e;
      visibility: visible;
      margin-left: -1px;
    }

    &::after {
      content: '';
      background: url('../../../assets/icons/select-arrow-down.svg') center
        no-repeat;
      width: 8px;
      height: 6px;
      position: absolute;
      top: 15px;
      right: 17px;
      cursor: pointer;
    }

    &.select-opened {
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 5px;

      &:after {
        background: url('../../../assets/icons/select-arrow-up.svg') center
          no-repeat;
      }
    }
  }

  .free-attractions {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;

    & .free-attractions-slider {
      margin-top: 30px;
    }
  }

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .prague-areas {
    margin-top: 40px;

    & .areas-wrapper {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      margin-top: 30px;
    }
  }

  .switches {
    margin-left: 59px;
  }
}

// common styles

h3,
h1 {
  // font-family: Open Sans Semibold, sans-serif;
  // font-weight: 600;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  color: $dark-blue;
}

.attractions-header {
  & .header-title {
    // background: rgba(37, 44, 62, 0.36);

    h1 {
      font-family: Arial, sans-serif;
      font-style: normal;
      font-weight: bold;
      color: #ffffff;

      text-transform: uppercase;
    }

    h3 {
      font-family: Open Sans Semibold, sans-serif;
      font-weight: 600;
      color: #ffffff;
    }
  }
}

::v-deep .attractions-search {
  width: 100%;
  height: 37px;
  background: #ffffff;
  border-radius: 5px;
  border: none;

  padding: 0;

  text-indent: 15px;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
}

::v-deep .attractions-search::placeholder {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(37, 44, 62, 0.6);
}

.search-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

::v-deep .autocomplete__results {
  max-height: 220px;
}

.magnifying-glass {
  width: 20px;
  height: 20px;
  background: url('../../../assets/icons/search.svg') center;
  cursor: pointer;
  right: 9px;
  position: absolute;
}

.categories-tabs {
  & .categories {
    background: $dark-blue;
    box-shadow: 0 8px 12px rgba(76, 72, 124, 0.08);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    & .categories-list {
      #all-attractions {
        font-family: Open Sans Bold, sans-serif;
        font-weight: bold;
        text-align: center;
      }

      .category {
        border: 1px solid #ffffff;
        box-sizing: border-box;
        border-radius: 5px;
        cursor: pointer;

        p {
          color: #ffffff;
        }

        &.active {
          background: $light-gray;

          p {
            color: #252c3e;
          }
        }
      }

      & .separator {
        width: 100%;
        height: 0;
        border: 1px solid $hover-orange;
        background: $hover-orange;
      }
    }
  }
}

.content {
  & .main-content {
    display: grid;
    min-height: 650px;
  }
}

.content-header {
  display: flex;
  flex-direction: row;
  align-items: center;

  & .switches {
    display: flex;
    flex-direction: row;

    :last-child {
      margin-right: 0;
    }

    & div {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }

    & .grid {
      background: url('../../../assets/icons/grid.svg') center;

      &.active {
        background: url('../../../assets/icons/grid-active.svg') center;
      }
    }

    & .list {
      background: url('../../../assets/icons/list.svg') center;

      &.active {
        background: url('../../../assets/icons/list-active.svg') center;
      }
    }

    & .map {
      background: url('../../../assets/icons/pin.svg') center;

      &.active {
        background: url('../../../assets/icons/pin-active.svg') center;
      }
    }
  }
}

::v-deep .filter-dropdown {
  background: #ffffff;
  border: 1px solid $dark-gray;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  & .inner-container {
    padding: 6px 17px 6px 15px;
    height: 100%;
    box-sizing: border-box;

    & .filters-list {
      & .selected-filter {
        font-family: Open Sans, sans-serif;
        font-weight: normal;
        font-size: 14px;
        line-height: 23px;
        color: #252527;
      }
    }
  }

  & .filters-container {
    position: absolute;
    top: 100%;
    width: 100%;
    border-radius: 0 0 5px 5px;
    background: #ffffff;
    visibility: hidden;
    z-index: 1;

    & .filters-list {
      & div {
        font-family: Open Sans, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 23px;
        color: #252527;
        padding-top: 3px;
        padding-bottom: 8px;
        padding-left: 15px;
        position: relative;

        &:before {
          content: '';
          width: 147px;
          height: 1px;
          background-color: $light-gray;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -73.5px;
        }

        &:hover {
          background-color: $light-gray;
        }

        &:last-child {
          padding-bottom: 10px;

          &:hover {
            border-radius: 0 0 5px 5px;
          }
        }
      }

      & .has-no-choices {
        padding: 0 !important;
      }
    }
  }

  &.select-opened .filters-container {
    border-bottom: 1px solid #fdca2e;
    border-left: 1px solid #fdca2e;
    border-right: 1px solid #fdca2e;
    visibility: visible;
    margin-left: -1px;
  }

  &::after {
    content: '';
    background: url('../../../assets/icons/select-arrow-down.svg') center
      no-repeat;
    width: 8px;
    height: 6px;
    position: absolute;
    top: 15px;
    right: 17px;
    cursor: pointer;
  }

  &.select-opened {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 5px;

    &:after {
      background: url('../../../assets/icons/select-arrow-up.svg') center
        no-repeat;
    }
  }
}

::v-deep .region-select {
  height: 35px;
  background: #ffffff;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  text-transform: capitalize;
  border: 1px solid $dark-gray;

  & .inner-container {
    padding: 6px 17px 6px 15px;
    height: 100%;
    box-sizing: border-box;

    & .selected-region {
      font-family: Open Sans, sans-serif;
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
      color: #252527;
    }
  }

  & .regions-container {
    position: absolute;
    top: 100%;
    width: 100%;
    border-radius: 0 0 5px 5px;
    box-sizing: content-box;
    background: #ffffff;
    visibility: hidden;
    z-index: 1;

    & .regions-list {
      max-height: 150px;
      overflow-y: scroll;
      text-transform: capitalize;

      & div {
        font-family: Open Sans, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 23px;
        color: #252527;
        padding-top: 3px;
        padding-bottom: 8px;
        padding-left: 15px;
        position: relative;

        &:before {
          content: '';
          width: 147px;
          height: 1px;
          background-color: $light-gray;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -73.5px;
        }

        &:hover {
          background-color: $light-gray;
        }

        &:last-child {
          padding-bottom: 10px;
        }
      }

      & .has-no-choices {
        padding: 0 !important;
      }
    }
  }

  &.select-opened .regions-container {
    border-bottom: 1px solid #fdca2e;
    border-left: 1px solid #fdca2e;
    border-right: 1px solid #fdca2e;
    visibility: visible;
    margin-left: -1px;
  }

  &::after {
    content: '';
    background: url('../../../assets/icons/select-arrow-down.svg') center
      no-repeat;
    width: 8px;
    height: 6px;
    position: absolute;
    top: 15px;
    right: 17px;
    cursor: pointer;
  }

  &.select-opened {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 5px;

    &:after {
      background: url('../../../assets/icons/select-arrow-up.svg') center
        no-repeat;
    }
  }
}

::v-deep .select-opened {
  border-top: 1px solid $yellow;
  border-left: 1px solid $yellow;
  border-right: 1px solid $yellow;
  border-radius: 5px 5px 0 0 !important;
}

.free-attractions {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;

  & .free-attractions-slider {
    margin-top: 30px;
  }
}

.row {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.prague-areas {
  margin-top: 40px;
}

.author {
  position: absolute;
  text-align: right;
  margin: -25px 0 -25px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: $light-gray;
  opacity: 0.9;
}

@media only screen and (max-width: $screen-width-xs) {
  ::v-deep .link {
    .show-all-btn {
      margin: 10px 8px;
      width: 100%;

      &:hover {
        border: 1px solid $dark-gray;
      }

      &:active {
        border: 1px solid rgba(37, 44, 62, 0.6);
      }
    }
  }

  .calculator-opened {
    position: fixed;
    width: 100%;
    top: 0;
    display: flex;
    flex-flow: column;
    height: 100vh;
    z-index: 120;
  }

  .calculator {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 100;
    height: 90px;
    display: flex;
    flex-flow: column;
  }

  .calculator-tip {
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: $orange;
    text-transform: uppercase;
    margin: 10px 30px 0;
  }

  .categories-tabs {
    & .categories {
      & .categories-list {
        & .separator {
          margin-bottom: 10px;
        }
      }
    }
  }

  .filter-dropdown-container {
    width: 100%;
  }

  ::v-deep .autocomplete__results {
    margin-top: -1px;
  }

  .search-container {
    z-index: 110;
  }

  .author {
    font-size: 9px;
    margin: -15px 0 -15px;
  }

  .load {
    display: none;
  }

  .no-results {
    font-family: Open Sans, sans-serif;
    font-weight: normal;
    font-size: 16px;
    padding: 8px;
  }
}
</style>
